'use client'

import type { CSSProperties, ReactNode } from 'react'

import HeroLcpBackground from '@/app/[locale]/components/HeroBlock/HeroLcpBackground'
import {
  NEWS_PAGE_HERO_IMAGE_ALT,
  NEWS_PAGE_LCP_DIMENSIONS,
  NEWS_PAGE_LCP_SOURCES
} from '@/lib/lcp/newsPageLcpAssets'

import S from './NewsPageHero.module.scss'
import NewsPageHeroImageLayers from './NewsPageHeroImageLayers'

type NewsPageHeroProps = {
  children: ReactNode
  /** Gap between header bottom and hero content. Default: list page (30px). */
  contentTopOffset?: number
  /** Mobile override for contentTopOffset. Falls back to contentTopOffset. */
  contentTopOffsetMobile?: number
  /** Fills the gap between the header and the hero content. */
  topSlot?: ReactNode
}

const NewsPageHero = ({
  children,
  contentTopOffset = 30,
  contentTopOffsetMobile,
  topSlot
}: NewsPageHeroProps) => {
  return (
    <section
      className={S.hero}
      style={
        {
          '--news-hero-content-offset': `${contentTopOffset}px`,
          ...(contentTopOffsetMobile != null
            ? {
                '--news-hero-content-offset-mobile': `${contentTopOffsetMobile}px`
              }
            : {})
        } as CSSProperties
      }
    >
      <div className={S.background} aria-hidden>
        <HeroLcpBackground
          alt={NEWS_PAGE_HERO_IMAGE_ALT}
          sources={NEWS_PAGE_LCP_SOURCES}
          dimensions={NEWS_PAGE_LCP_DIMENSIONS}
          className={S.backgroundImage}
        />
        <NewsPageHeroImageLayers />
      </div>
      {topSlot && <div className={S.topSlot}>{topSlot}</div>}
      <div className={S.content}>{children}</div>
    </section>
  )
}

export default NewsPageHero
